import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert/Alert';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { isEmpty } from 'lodash';
import ZajavlSelect from './zajavl_select';
import SendStatusForm from './send_status_form';
import { filterTemplatesDocumentsForZajavlsConsentOrRefusal, getContestsLevelsEduUnique } from '@helpers/functions';
import { ZAJAVL_CONSENT_FILE_TYPE } from '../../../constants';
import {
    changeFilesNotTemporaryStatus,
    combineUploadFileInfoWithApiFile,
    deleteFileRequest,
    saveFilesRequest,
} from '@services/filemanager';
import {addNotification, loadingApplication} from '@componentDP/js_react/redux/actions/application';
import {filesInfoReceived} from '@componentDP/js_react/redux/actions/files';
import {sendConsentOrRefusalZajavlStatus} from '@componentDP/js_react/redux/actions/zajavls_consent_or_refusal';
import ConfirmRewriteFiles from './confirm_rewrite_files';
import {
    ACCEPTED_ZAJAVL_WITH_SEND_CONSENT_STATUS,
    ACCEPTED_ZAJAVL_WITH_SEND_DENIAL_STATUS,
} from '@assets/js/constants/statusOnlineZajavl';
import ErrorText from '../../simple/ErrorText';
import Typography from "@material-ui/core/Typography";
import Box from '@material-ui/core/Box';
import {isAnyZajavlCompetitionsNeedConsentOrDenial} from "../../../helpers/functions";
import {FilemanagerApi} from '@requests';
import {withTranslation} from "react-i18next";

class ConsentOrRefusalContainer extends React.Component {
    constructor(props) {
        super(props);
        this.defaultState = {
            selectedZajavlId: null,
            selectedFileType: ZAJAVL_CONSENT_FILE_TYPE,
            loadedFiles: null,
            sendStatusDisabled: true,
            canSendStatus: false,
            openConfirmRewriteFilesDialog: false,
            comment: null,
        };
        this.state = this.defaultState;
    }

    handleChangeZajavlSelect = (e) => {
        let state = this.state;
        const selectedZajavlId = Number(e.target.value);
        if (this.state.selectedZajavlId) {
            state = {...this.defaultState};
        }
        this.setState({...state, selectedZajavlId});
    };

    handleChangeFileType = (e) => {
        const state = this.state;
        const selectedFileType = Number(e.target.value);
        this.setState({...state, selectedFileType});
    };

    handleRemoveFile = async (removeFileId) => {
        const state = this.state;
        const {apiDomainFilemanager, loadingApplication} = this.props;
        loadingApplication(true);
        const deleteResult = await deleteFileRequest(removeFileId, apiDomainFilemanager);
        if (!deleteResult.hasOwnProperty('error')) {
            const {loadedFiles} = state;
            const result = loadedFiles.filter(({id}) => id !== removeFileId);
            this.setState({...state, loadedFiles: result});
        } else {
            this.props.addNotification({message: deleteResult.error, type: 'error'});
        }
        this.changeSendStatusBtnAvailability();
        loadingApplication(false);
    };

    handleDownloadFile = async (fileId) => {
        const {apiDomainFilemanager} = this.props;
        const filemanagerApi = new FilemanagerApi(apiDomainFilemanager);
        await filemanagerApi.downloadFile(fileId);
    };

    handleOnDropFile = async (acceptedFiles) => {
        const {vuzId, apiDomainFilemanager, loadingApplication} = this.props;
        loadingApplication(true);
        const requestsPayload = await saveFilesRequest(acceptedFiles, vuzId, apiDomainFilemanager);
        const state = this.state;
        let {loadedFiles} = state;
        if (!loadedFiles) {
            loadedFiles = [];
        }
        const newApiFileSpr = [];
        requestsPayload.forEach(requestPayload => {
            const {result: requestResult, file} = requestPayload;
            if (!requestResult.hasOwnProperty('error')) {
                const formattedFileInfo = {
                    ...combineUploadFileInfoWithApiFile(requestResult, file),
                };
                loadedFiles.push(formattedFileInfo);
                newApiFileSpr.push(requestResult);
            } else {
                const error = `Файл: ${file.name}:<br>${requestResult.error}`;
                this.props.addNotification({message: error, type: 'error'});
            }
        });
        if (!isEmpty(newApiFileSpr)) {
            this.props.filesInfoReceived(newApiFileSpr);
        }
        this.setState({...state, loadedFiles});
        this.changeSendStatusBtnAvailability();
        loadingApplication(false);
    };

    handleSendStatus = () => {
        const {selectedZajavlId, canSendStatus} = this.state;
        const {zajavls} = this.props;
        const selectedZajavl = zajavls.find(zajavl => Number(zajavl.id) === selectedZajavlId);
        if ([ACCEPTED_ZAJAVL_WITH_SEND_CONSENT_STATUS, ACCEPTED_ZAJAVL_WITH_SEND_DENIAL_STATUS].includes(selectedZajavl.status)) {
            if (canSendStatus) {
                this.setState({...this.state, openConfirmRewriteFilesDialog: false});
                this.sendStatus();
            } else {
                this.setState({...this.state, canSendStatus: false, openConfirmRewriteFilesDialog: true});
            }
        } else {
            this.setState({...this.state, canSendStatus: true});
            this.sendStatus();
        }
    };

    sendStatus = () => {
        const {selectedZajavlId, selectedFileType, loadedFiles, comment} = this.state;
        const fileIds = loadedFiles
            ? loadedFiles.map(({id}) => id)
            : [];
        const data = {
            selectedFileType,
            fileIds,
            comment
        };
        this.props.sendConsentOrRefusalZajavlStatus(selectedZajavlId, data, this.successSendStatusCallback);
    };

    successSendStatusCallback = async () => {
        const {loadedFiles} = this.state;
        const {apiDomainFilemanager} = this.props;
        const fileIds = loadedFiles.map(({id}) => id);
        await changeFilesNotTemporaryStatus(fileIds, apiDomainFilemanager);
        this.setState(this.defaultState);
    };

    changeSendStatusBtnAvailability = () => {
        const state = this.state;
        this.setState({...state, sendStatusDisabled: isEmpty(this.state.loadedFiles)});
    };

    handleAgreeConfirmRewriteFiles = () => {
        const state = this.state;
        this.setState({...state, canSendStatus: true, openConfirmRewriteFilesDialog: false});
        this.sendStatus();
    };

    handleDisagreeConfirmRewriteFiles = () => {
        const state = this.state;
        this.setState({...state, canSendStatus: false, openConfirmRewriteFilesDialog: false});
    };

    handleChangeComment = (e) => {
        const comment = e.target.value;
        const state = this.state;
        this.setState({...state, comment});
    };

    render() {
        const {zajavls, templatesDocuments, i18n} = this.props;
        const {selectedZajavlId, selectedFileType, loadedFiles, sendStatusDisabled, openConfirmRewriteFilesDialog, handleChangeComment, comment} = this.state;
        let selectedZajavl = null;
        if (selectedZajavlId) {
            selectedZajavl = zajavls.find(zajavl => Number(zajavl.id) === selectedZajavlId);
        }
        let sendStatusForm = null;
        if (selectedZajavl) {
            const showSendForm = isAnyZajavlCompetitionsNeedConsentOrDenial(selectedZajavl);
            if (showSendForm) {
                const contestsLevelsEduUnique = getContestsLevelsEduUnique(selectedZajavl.contests);
                const filteredDocumentTemplates = filterTemplatesDocumentsForZajavlsConsentOrRefusal(templatesDocuments, contestsLevelsEduUnique);
                const formProps = {
                    zajavl: selectedZajavl,
                    templates: filteredDocumentTemplates,
                    handleChangeFileType: (e) => this.handleChangeFileType(e),
                    handleRemoveFile: (id) => this.handleRemoveFile(id),
                    handleDownloadFile: (id) => this.handleDownloadFile(id),
                    handleOnDropFile: (acceptedFiles) => this.handleOnDropFile(acceptedFiles),
                    selectedFileType,
                    loadedFiles,
                    handleSendStatus: () => this.handleSendStatus(),
                    sendStatusDisabled,
                    handleChangeComment: (e) => this.handleChangeComment(e),
                    comment,
                };
                sendStatusForm = <SendStatusForm {...formProps}/>;
            } else {
                const msg =
                    'Для заявлений, поданных на конкурсы аспирантуры, адъюнктуры, ассистентуры, ординатуры, интернатуры,' +
                    ' СПО не предусмотрено возможности' +
                    ' отправки документов о согласии/отказе о зачислении';
                sendStatusForm = <Box m={2} ><Alert severity="info"><Typography>{msg}</Typography></Alert></Box>
            }
        }

        const isEn = i18n.language === "en";

        return (
            <Grid container spacing={2}>
                {!isEmpty(zajavls)
                    ? (
                        <React.Fragment>
                            <Grid item xs={12}>
                                <Alert icon={<HelpOutlineIcon fontSize="inherit"/>} severity="info">
                                    {isEn
                                        ? 'To submit your enrollment acceptance or refusal:'
                                        : 'Чтобы отправить согласие или отказ от зачисления:'}
                                    <ol>
                                        <li>
                                            {isEn ? 'Select an application' : 'Выберите заявление'}
                                        </li>
                                        <li>
                                            {isEn ? 'Download the required template' : 'Скачайте нужный шаблон'}
                                        </li>
                                        <li>
                                            {isEn
                                                ? 'Fill in the information, sign, and scan'
                                                : 'Заполните информацию, подпишите, отсканируйте'}
                                        </li>
                                        <li>
                                            {isEn
                                                ? 'Select file type (acceptance or refusal)'
                                                : 'Выберите тип файла (согласие или отказ)'}
                                        </li>
                                        <li>
                                            {isEn ? 'Attach the scanned file' : 'Прикрепите отсканированный файл'}
                                        </li>
                                        <li>
                                            {isEn ? 'Submit for moderation' : 'Отправьте информацию на модерацию'}
                                        </li>
                                    </ol>
                                </Alert>
                            </Grid>
                            <Grid item xs={12}>
                                <ZajavlSelect zajavls={zajavls} selectedValue={selectedZajavlId}
                                              handleChange={(e) => this.handleChangeZajavlSelect(e)}/>
                            </Grid>
                            <Grid item xs={12}>
                                {sendStatusForm}
                            </Grid>
                            {
                                openConfirmRewriteFilesDialog
                                    ? <ConfirmRewriteFiles handleDisagree={this.handleDisagreeConfirmRewriteFiles}
                                                           handleAgree={this.handleAgreeConfirmRewriteFiles}/>
                                    : null
                            }
                        </React.Fragment>
                    )
                    : (
                        <React.Fragment>
                            <Grid item xs={12}>
                                <ErrorText message={isEn ? 'No accepted applications' : 'Отсутствуют принятые заявления'}/>
                            </Grid>
                        </React.Fragment>
                    )
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    const {zajavls, vuzId, templatesDocuments, apiDomainFilemanager} = state;
    const filteredZajavls = zajavls.filter(zajavl => zajavl.is_show_into_consent_or_denial_list_allowed);
    return {
        zajavls: filteredZajavls,
        templatesDocuments,
        apiDomainFilemanager,
        vuzId,
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    addNotification,
    loadingApplication,
    filesInfoReceived,
    sendConsentOrRefusalZajavlStatus,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConsentOrRefusalContainer));
